// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a1f963a3","488":"f8fd27b0","644":"fab9761c","732":"50d18dd0"}[chunkId] + ".chunk.js";
};